<template>
	<side-window :tabs="[]" :active="active" class="contact" title="Booking" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<form-line-layout>
						<date-select-view label="Fra" v-model="from_date" :controller="$store.state.popupController" />
						<clock-select-view v-model="from_time" :controller="$store.state.popupController" />
					</form-line-layout>
					<form-line-layout>
						<date-select-view label="Til" v-model="to_date" :controller="$store.state.popupController" />
						<clock-select-view v-model="to_time" :controller="$store.state.popupController" />
					</form-line-layout>
				</div>
			</form-grid-layout>
		</div>
		<div slot="footer">
			<button-view label="Gem" @click="onAddButtonClick" />
		</div>
	</side-window>
</template>

<script>
	import MoveTaskModel from '../model/MoveTask'

	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import FileListView from '../views/FileListView';
	import RouteView from '../views/RouteView';
	import RequirementsView from '../views/RequirementsView';
	import PhotosView from '../views/PhotosView';
	import InstructionsView from '../views/InstructionsView';
	import PackagingView from '../views/PackagingView';
	import OrderView from '../views/OrderView';
	import EmployeeSelectView from '../views/EmployeeSelectView';
	import AddressView from '../views/AddressView';

	import merge from '../functions/merge'
 
	const stop = {

	};

	export default {
		data: function () {
			return {
				packaging: [],
				ORDER: [],
				active: 'details',
				instructions: [],
				departments: [],
				types: [],
				status: [],
				employees: [],
				vehicles: []
			};
		},
		watch: {
	
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'FileListView': FileListView,
			'RouteView': RouteView,
			'RequirementsView': RequirementsView,
			'PhotosView': PhotosView,
			'InstructionsView': InstructionsView,
			'PackagingView': PackagingView,
			'OrderView': OrderView,
			'EmployeeSelectView': EmployeeSelectView,
			'AddressView': AddressView
		},
		computed: {
			tabs: function () {
				return [
					{
						name: 'details',
						label: 'Detaljer'
					},
					{
						name: 'employees',
						label: 'Medarbejdere'
					},
					{
						name: 'vehicles',
						label: 'Køretøjer'
					}
				];
			},
			_employees() {
				return this.employees.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			},
			_vehicles() {
				return this.vehicles.map(function (ent) {
					return {
						label: ent.name,
						value: ent.id
					};
				});
			}
		},
		props: {
			id: Number,
			form: Boolean,
			from_date: String,
			from_time: String,
			to_date: String,
			to_time: String,
			submit: {
				type: Function,
				default: function () {}
			},
			entity: {
				type: Object,
				default() {
					return Object.assign({}, MoveTaskModel);
				}
			}
		},
		methods: {
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			onAddButtonClick() {
				
				this.submit(this.from_date + ' ' + this.from_time, this.to_date + ' ' + this.to_time);
			}
		},
		mounted: function() {
			
			

			var self = this;

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/planning/reservations/types/')
				.then(function (r) {
					self.types = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/planning/reservations/status/')
				.then(function (r) {
					self.status = r.data._items;
					//self.departments = r.data._items;
				});

			this.axios
				.get('/employees/')
				.then(function (r) {
					self.employees = r.data._items;
					//self.departments = r.data._items;

					
				});

			this.axios
				.get('/fleet/vehicles/')
				.then(function (r) {
					self.vehicles = r.data._items;
					//self.departments = r.data._items;
				});

			/*this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
					//self.entity.roles = {...self._roles, ...self.entity.roles};
				});*/

		}
	}
</script>

<style lang="scss">
	
</style>
